const state = {
  estadoCivils: [{value: 'Solteiro', text: 'Solteiro'}, {value: 'Casado', text: 'Casado'}],
  generos: [{value: 'Masculino', text: 'Masculino'}, {value: 'Feminino', text: 'Feminino'}],
  tipoEnderecos: [{value: 'Residencial', text: 'Residencial'}, {value: 'Comercial', text: 'Comercial'}, {value: 'Parente', text: 'Parente'}],
  tipoTelefones: [{value: 'Pessoal', text: 'Pessoal'}, {value: 'Residencial', text: 'Residencial'}, {value: 'Comercial', text: 'Comercial'}, {value: 'Recado', text: 'Recado'}],
  tipoprocessos: [{value: 1, text: 'Administrativo'}, {value: 2, text: 'Jurídico'}],
  ufs: [
    {value: 'AC', text: 'ACRE'}, 
    {value: 'AL', text: 'ALAGOAS'}, 
    {value: 'AM', text: 'AMAZONAS'}, 
    {value: 'AP', text: 'AMAPA'}, 
    {value: 'BA', text: 'BAHIA'}, 
    {value: 'CE', text: 'CEARA'}, 
    {value: 'DF', text: 'DISTRITO FEDERAL'}, 
    {value: 'ES', text: 'ESPIRITO SANTO'}, 
    {value: 'GO', text: 'GOIAS'}, 
    {value: 'MA', text: 'MARANHAO'}, 
    {value: 'MT', text: 'MATO GROSSO'}, 
    {value: 'MS', text: 'MATO GROSSO DO SUL'}, 
    {value: 'MG', text: 'MINAS GERAIS'}, 
    {value: 'PA', text: 'PARA'},
    {value: 'PB', text: 'PARAIBA'},
    {value: 'PR', text: 'PARANA'},
    {value: 'PE', text: 'PERNAMBUCO'},
    {value: 'PI', text: 'PIAUI'},
    {value: 'RN', text: 'RIO GRANDE DO NORTE'},
    {value: 'RS', text: 'RIO GRANDE DO SUL'},
    {value: 'RJ', text: 'RIO DE JANEIRO'},
    {value: 'RO', text: 'RONDONIA'},
    {value: 'RR', text: 'RORAIMA'},
    {value: 'SC', text: 'SANTA CATARINA'},
    {value: 'SP', text: 'SAO PAULO'},
    {value: 'SE', text: 'SERGIPE'},
    {value: 'TO', text: 'TOCANTINS'},
  ],
}

const getters = {
  ESTADO_CIVIL: state => state.estadoCivils,
  GENERO: state => state.generos, 
  TIPO_TELEFONES: state => state.tipoTelefones,
  TIPO_ENDERECOS: state => state.tipoEnderecos,
  UFS: state => state.ufs,
  TIPOPROCESSOS: state => state.tipoprocessos,
}

export default {
  namespaced: true,
  state,
  getters,
} 


// WEBPACK FOOTER //
// ./src/store/modules/enums/index.js